import { Component } from '@angular/core';
import { CommandService } from '../../services/command.service';
import { NgStyle, AsyncPipe } from '@angular/common';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

@Component({
    selector: 'gbc-command-spinner',
    templateUrl: './command-spinner.component.html',
    styleUrls: ['./command-spinner.component.scss'],
    imports: [
    LoadingSpinnerComponent,
    NgStyle,
    AsyncPipe
],
})
export class CommandSpinnerComponent {
  constructor(public commandService: CommandService) {}
}
